<template>
	<div>
		<CRow>
			<CCol>
				<CInput
					type="text"
					name="text"
					label="Raison de litige"
					:value="complaint ? complaint.text : null" />
			</CCol>
		</CRow>
	</div>
</template>

<script>
	export default {
		name: 'ComplaintReasonForm',
		props: {
			complaint: {
				type: Object,
				default: null,
			},
		},
	};
</script>
